module.exports = __webpack_public_path__ + "static/media/eye-grey.fe4b9762.svg";